/*
  作者：hejianbo    
  时间：2020-1-27
  描述：采编中心-多类型附件上传弹窗
*/
'use strict';
angular.module('uploadAttachmentModule', []).controller('uploadAttachmentCtrl', [
    '$scope',
    '$modalInstance',
    'modalDialog',
    function($scope, $modalInstance, modalDialog) {
        initStatus();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                fileList: [],
                uploadImgs: [],
                uploadedSrcs: [],
                progress: {},
            };
            $scope.status = {
                maxSize: 20, // 单图最大尺寸 单位MB
                scaleWidth: 700, // 缩放宽度
            };
            $scope.appendixUpload = { 
                options: {
                    maxSize: 50,
                    maxCount: 9,
                    isShowLabel: false,
                    labelName: '附件',
                    isShowAddIcon: false,
                    addButtonName: '本地上传',
                    uploadUrl: '/wcm/openapi/uploadFile',
                    listStyle: 'card'
                },
                fileList: [],
            };
        }

        $scope.confirm = function() {
            if (!$scope.appendixUpload.fileList.length) {
                modalDialog.alertType('', '没有上传文件', 'error', false);
                return;
            }
            $modalInstance.close($scope.appendixUpload.fileList);
        };

        /**
         * [cancel 关闭]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss('cancel');
        };

        $scope.uploadIsRunning = function() {
            return false;
        };

        $scope.uploadEnd = function() {
            return true;
        };

        /**
         * [fileUploadSuccess 附件上传成功的回调]
         *
         * @param   {[type]}  resp  [resp description]
         * @param   {[type]}  file  [resp description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.fileUploadSuccess = function(resp, file) {
            if (resp.data.error) {
                file.FILEINFO = '上传失败';
            } else {
                delete file.file;
                file.FILEINFO = '上传成功';
                file.FileDesc = file.FileName;
                file.FileName = resp.data.imgName;
                file.FileSize = resp.data.fileSizeOfKB;
                file.src = resp.data.imgSrc;
            }
        };

        /**
         * [fileUploadFail 文件上传失败处理]
         *
         * @param   {[type]}  resp  [resp description]
         * @param   {[type]}  file  [file description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.fileUploadFail = function(resp, file) {
            if (resp.status === '413') {
                file.FILEINFO = '文件太大，不得大于' + $scope.appendixUpload.options.max + 'MB!';
            } else {
                file.FILEINFO = '未知错误!';
            }
        };

        /**
         * [fileUploadProgress 文件上传中]
         *
         * @param   {[type]}  evt   [evt description]
         * @param   {[type]}  file  [file description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.fileUploadProgress = function(evt, file) {
            file.FILEINFO = '正在上传';
            file.progress = parseInt(evt.loaded / evt.total * 100) + '%';
        };
    },
]);
